import i18n from "i18next";                      
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: 
      {
        translation: 
        {
          nav_menu1:"About us",
          nav_menu2:"Services",
          nav_menu3:"Testimonials",
          nav_menu4:"Our Team",
          nav_menu5:"Contact Us",
          home_title:"Experts in Agronomic Biosystems Managed with IoT Metrics and Real-Time Control Techniques, Related to Agriculture 5.0",
          home_text:"We provide specialized agronomic consulting services in process control engineering for continuous management: water, soil, crops, and climate monitoring. We focus on the efficient use of resources to increase productivity and add value to the supply chains of plant and animal products.",
          about_title:"About CyberAgro 5.0",
          about_text1:"CyberAgro 5.0 is a prestigious business consulting firm based in Costa Rica with a proven track record, empowering our clients and companies in the agri-food sector to reach their full potential through the efficient use of water, soil, inputs, and human talent.",
          about_text2:"At CyberAgro 5.0, we believe in building lasting relationships with our clients based on trust, integrity, and results. We are committed to providing the highest level of service and support to help businesses thrive in today's competitive agri-food market.",
          services_main_title:"Services",
          services_title1:"Data Mining",
          services_text1:"You can trust us to optimize your management processes through our agricultural BigData platform, ensuring greater profitability and sustained, sustainable growth.",
          services_title2:"Digitalization of your crop fields",
          services_text2:"CyberAgro 5.0 leverages cutting-edge IoT technologies (water, soil, plant, and climate sensors, drones, and remote sensing) to digitize its production units and make them more productive, efficient, and resilient.",
          services_title3:"Training",
          services_text3:"Our customers praise our training programs that empower teams with advanced skills essential for success in precision production environments.",
          services_title4:"Risk management",
          services_text4:"Is your business affected by unforeseen risks? We implement robust strategies to effectively protect your operations with future forecasts related to agrometeorology.",
          services_title5:"Strategy",
          services_text5:"We help you design customized strategies that align with your business objectives and effectively drive results.",
          services_title6:"Operations",
          services_text6:"Is your company struggling to be efficient? Our team of experts will optimize your operations to maximize your productivity.",
          services_title7:"Marketing",
          services_text7:"Partner with us for innovative marketing solutions that increase your visibility and attract the right customers.",
          contacto_title:"Contact Us",
          contacto_text1:"Name",
          contacto_text2:"Email Address",
          contacto_text3:"Phone number",
          contacto_text4:"Message",
          contacto_text5:"The Message has been sent.",
          contacto_btn:"Send",
        },
      },
      es: {
        translation: 
        {
            nav_menu1:"Acerca de Nosotros",
            nav_menu2:"Servicios",
            nav_menu3:"Testimonios",
            nav_menu4:"Nuestro Equipo",
            nav_menu5:"Contacto",
            home_title:"Expertos en Biosistemas Agronómicos Gestionados con Métricas y Técnicas IoT de Control en Tiempo real, Relacionadas con la Agricultura 5.0",
            home_text:"Desarrollamos consultoría Agronómica Especializada en Ingeniería de Procesos de Control para el Manejo del Continuo: agua, suelo, cultivos y monitoreo del clima. Enfocándonos en el uso eficiente de los recursos para aumentar productividad y agregarle valores a las cadenas de suministros de productos de origen vegetal y animal.",
            about_title:"Acerca de CyberAgro 5.0",
            about_text1:"CyberAgro 5.0 es una prestigiosa firma de consultoría empresarial con sede en Costa Rica y con una trayectoria comprobada, fortaleciendo a nuestros clientes y empresas del sector agroalimentario, en alcanzar su máximo potencial en el uso eficiente de los recursos agua, suelo, insumos y talento humano.",
            about_text2:"En CyberAgro 5.0, creemos en construir relaciones duraderas con nuestros clientes basadas en la confianza, la integridad y los resultados. Nos comprometemos a brindar el más alto nivel de servicio y soporte para ayudar a las empresas a prosperar en el competitivo mercado actual del sector agroalimentario.",
            services_main_title:"Servicios",
            services_title1:"Minería de Datos",
            services_text1:"Puede confiar en nosotros para optimizar sus procesos de gestión a través de nuestra plataforma BigData agro productiva, asegurando una mayor rentabilidad y un crecimiento sostenido y sostenible.",
            services_title2:"Digitalización de sus campos de cultivos",
            services_text2:"CyberAgro 5.0, cuenta con las mejores tecnologías IoT (sensores de agua, suelo, planta y clima, drones y teledetección), para digitalizar sus unidades productivas y hacerlas más productivas, eficientes y resilientes.",
            services_title3:"Capacitación",
            services_text3:"Nuestros clientes elogian nuestros programas de capacitación que empoderan a los equipos con habilidades avanzadas que son esenciales para el éxito en entornos productivos de precisión.",
            services_title4:"Gestión de riesgos",
            services_text4:"¿Su negocio se ve afectado por riesgos imprevistos? Implementamos estrategias sólidas para proteger sus operaciones eficazmente con pronósticos futuros relacionados a la agro meteorología.",
            services_title5:"Estrategia",
            services_text5:"Le ayudamos a diseñar estrategias personalizadas que se alineen con sus objetivos comerciales e impulsen resultados de manera efectiva.",
            services_title6:"Operaciones",
            services_text6:"¿Su empresa tiene dificultades para ser eficiente? Nuestro equipo de expertos optimizará sus operaciones para maximizar su productividad",
            services_title7:"Marketing",
            services_text7:"Asóciese con nosotros para obtener soluciones de marketing innovadoras que aumenten su visibilidad y atraigan a los clientes adecuados.",
            contacto_title:"Contacto",
            contacto_text1:"Nombre",
            contacto_text2:"Dirección de Correo Electrónico",
            contacto_text3:"Número de Teléfono",
            contacto_text4:"Mensaje",
            contacto_text5:"El Mensaje ha sido enviado.",
            contacto_btn:"Enviar",
        },
      },
    },
  });

export default i18n;